import { render, staticRenderFns } from "./signUpFooter.vue?vue&type=template&id=550e8c54&scoped=true&"
import script from "./signUpFooter.vue?vue&type=script&lang=js&"
export * from "./signUpFooter.vue?vue&type=script&lang=js&"
import style0 from "./signUpFooter.vue?vue&type=style&index=0&id=550e8c54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550e8c54",
  null
  
)

export default component.exports